import React from "react";
import { FaSignOutAlt } from "react-icons/fa";

export default function LogoutPopup({ isOpen, onCancel, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">

      <div className="bg-white rounded-2xl p-6 w-[90%] max-w-sm text-center shadow-2xl">

        <div className="flex justify-center mb-4">
          <div className="bg-red-100 text-red-600 p-4 rounded-full">
            <FaSignOutAlt size={20} />
          </div>
        </div>

        <h2 className="text-xl font-bold text-gray-800 mb-2">
          Confirm Logout
        </h2>

        <p className="text-gray-500 text-sm mb-6">
          Are you sure you want to logout?
        </p>

        <div className="flex gap-3">

          <button
            onClick={onCancel}
            className="w-full py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="w-full py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
          >
            Logout
          </button>

        </div>

      </div>
    </div>
  );
}